import classNames from 'classnames';
import { useState } from 'react';
import { Card, Features, Footer, Hero, Logos, MobileHeader, Profile, Start } from '../components';
import { AuthSkeleton } from '../layout';

const Register = () => {
  const [isSuccess, setIsSuccess] = useState(false);

  const _handleRegister = () => {
    setIsSuccess(true);
  };
  return (
    <>
      <MobileHeader
        actions={
          <>
            <a>Already have an account?</a>
            <a href='/login' className='primary bg-gradient rounded-full'>
              Login
            </a>
          </>
        }
      />
      <AuthSkeleton>
        <Card
          className={classNames('register', isSuccess && 'success')}
          title={`Create user`}
          subtitle='Could you add more text here that  user easily understand!'
          action='Register with Magic Link'
          onClick={_handleRegister}
        />
      </AuthSkeleton>
    </>
  );
};
export default Register;
